import SidebarShell from "@/components/SidebarShell/SidebarShell.vue";
import SidebarContext from "@/components/SidebarContext/SidebarContext.vue";
import SidebarUserFooter from "@/components/SidebarUserFooter/SidebarUserFooter.vue";
import brand_details from "@/data/brand_details";
import { menuItems, formatProperties } from "@/data/sidebar_config";

import { get_user_profile } from "@/router";

const details = brand_details();

export default {
  name: "PropertySidebar",

  components: {
    SidebarShell,
    SidebarContext,
    SidebarUserFooter
  },

  props: {
    active_property: {
      type: Object,
      required: true
    },
    properties: {
      type: Array,
      required: true
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return ({
      active_menu_item: null,
      dropdownOpen: false,
      openCollapsedGroup: null,
      openAccordion: "understand",
      entity_name: details.sub_entity_name,
      entity_subtitle: details.sub_entity_subtitle,
      full_name: "Guest User",
      initials: "GU",
      bolide_short_logo: ""
    });
  },

  computed: {
    menuItems() {
      return menuItems;
    },
    propertiesFormatted() {
      return formatProperties(this.properties);
    }
  },

  mounted() {
    this.load_user_name();

    this.bolide_short_logo = getComputedStyle(document.documentElement)
      .getPropertyValue("--brand-logo")
      .replace(/['"]+/g, "");

    if (!this.active_menu_item && this.active_property) {
      this.select_menu_item("socio-impact-analysis");
    }

    document.addEventListener("click", this.handleOutsideClick);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },

  watch: {
    active_property(newVal, oldVal) {
      if (!oldVal || newVal?.id !== oldVal?.id) {
        this.active_menu_item = "socio-impact-analysis";
        this.openCollapsedGroup = null;
      }
    },
    collapsed(collapsed) {
      if (!collapsed) {
        this.openCollapsedGroup = null;
      }
    }
  },

  methods: {
    toggleAccordion(groupKey) {
      this.openAccordion =
        this.openAccordion === groupKey ? null : groupKey;
    },

    isAccordionOpen(groupKey) {
      return this.openAccordion === groupKey;
    },

    load_user_name() {
      const user = get_user_profile();
      let name = "Guest User";

      if (user && (user.first_name || user.last_name)) {
        name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      } else {
        const first = sessionStorage.getItem("first_name") || "";
        const last = sessionStorage.getItem("last_name") || "";
        name = `${first} ${last}`.trim() || "Guest User";
      }

      if (name === "Guest User" && user?.email) {
        name = user.email.split("@")[0];
      }

      const parts = name.split(" ");
      const initials =
        ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || "GU";

      this.full_name = name;
      this.initials = initials;
    },

    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;

      if (this.dropdownOpen) {
        this.openCollapsedGroup = null;
      }
    },

    switchProperty(item) {
      this.dropdownOpen = false;
      this.openCollapsedGroup = null;

      this.$emit("switch-property", item.id);
      this.active_menu_item = "socio-impact-analysis";
    },

    backToGlobal() {
      this.dropdownOpen = false;
      this.openCollapsedGroup = null;
      this.$emit("go-back");
    },

    select_menu_item(menuItem) {
      if (this.active_menu_item === menuItem) return;

      this.active_menu_item = menuItem;
      this.openCollapsedGroup = null;

      // Only emit event if active_property is available
      if (this.active_property) {
        this.$emit("property-menu-selected", {
          menuItem,
          propertyId: this.active_property.id,
          propertyName: this.active_property.title
        });
      }
    },

    is_section_active(section) {
      if (!section.children) return false;
      return section.children.some(child => child.key === this.active_menu_item);
    },

    toggleCollapsedGroup(groupKey) {
      this.dropdownOpen = false;
      this.openCollapsedGroup =
        this.openCollapsedGroup === groupKey ? null : groupKey;
    },

    isCollapsedGroupOpen(groupKey) {
      return this.openCollapsedGroup === groupKey;
    },

    handleOutsideClick(event) {
      if (!this.$el?.contains(event.target)) {
        this.openCollapsedGroup = null;
      }
    }
  }
};
